const REMEMBERED_EMAIL_KEY = 'nobgp.rememberedEmail'

// WorkOS `authentication_method` values that mean "typed an email into AuthKit".
// Anything else — GoogleOAuth, SSO, Impersonation — signed in without one.
const EMAIL_METHODS = new Set(['MagicAuth', 'Password'])

// ⚠⚠ BOTH HELPERS SWALLOW STORAGE FAILURES, AND THAT IS BLAST RADIUS RATHER THAN
// HABIT. `localStorage` throws on mere ACCESS in a browser told to block site data,
// and neither caller can absorb it: `rememberedEmail()` is evaluated as an argument
// to `signIn(...)` inside SignIn's try, whose catch only logs and resets the
// spinner — so a throw leaves the button dead with no way in and nothing on screen —
// and `rememberEmail()` runs inside AuthCallbackPage's try, whose catch renders
// "Authentication failed" over a session that succeeded one line earlier. A prefill
// is a convenience and must never be able to cost the sign-in itself. The app's
// other localStorage callers are unguarded because every one of them is reached
// only AFTER this one has already let the user in.
export const rememberedEmail = () => {
  try {
    return localStorage.getItem(REMEMBERED_EMAIL_KEY)
  } catch {
    return null
  }
}

// Called on every completed sign-in, and deliberately clears as often as it stores:
// a Google user handed their own address back would read it as an invitation to
// press "Continue with email", which is not how their account signs in. Only an
// email sign-in earns a prefill, and the next Google sign-in takes it away again.
export const rememberEmail = (email: string | null, method: string | null) => {
  try {
    if (email && method && EMAIL_METHODS.has(method)) {
      localStorage.setItem(REMEMBERED_EMAIL_KEY, email)
      return
    }

    localStorage.removeItem(REMEMBERED_EMAIL_KEY)
  } catch {
    // No prefill next time, and nothing else changes. See above: the one thing
    // this must not do is fail the sign-in it is decorating.
  }
}
